import { type Plugin } from "@nuxt/types";

import Amplitude from "@/utils/amplitude";
import Experiment from "@/utils/experiments/client";
import logger, { logLevel } from "@/utils/logger";

declare module "vue/types/vue" {
  interface Vue {
    $amplitude?: Amplitude;
  }
}

declare module "@nuxt/types" {
  interface Context {
    $amplitude?: Amplitude;
  }
}

declare module "vuex/types/index" {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface Store<S> {
    $amplitude?: Amplitude;
  }
}

const plugin: Plugin = (context, inject) => {
  const amplitudeConfig = context.$config.amplitude;
  // Eventing
  const amplitude = new Amplitude(amplitudeConfig.key, context, {
    // Explicitly keep attribution referrer, utm, fbclid, and gclid enabled
    attribution: {
      disabled: false,
    },
  });

  inject("amplitude", amplitude);
  context.$amplitude = amplitude;

  // Experimentation
  if (amplitudeConfig.experimentsKey === undefined) {
    return;
  }

  try {
    const experiment = new Experiment(amplitudeConfig.experimentsKey, context);

    inject("experiments", experiment);
    context.$experiments = experiment;
  } catch (error) {
    logger(logLevel.ERROR, "Error initializing experimentation platform", {}, error);
  }
};

export default plugin;
